import AnalyticsTracking from './AnalyticsTracking';
import Confetti from './Confetti';
import MagicAnchor from './MagicAnchor';
import Overlay from './Overlay';
import PageSectionAnchor from './PageSectionAnchor';
import Toggler from './Toggler';
import Typer from './Typer';
import StatisticsInterval from './StatisticsInterval';

export default ({
    AnalyticsTracking,
    Confetti,
    MagicAnchor,
    Overlay,
    PageSectionAnchor,
    Toggler,
    Typer,
    StatisticsInterval,
});
